import moment from 'moment';
import { bool, string, object } from 'prop-types';
import { useEffect, useState, useRef } from 'react';

const InputMonthYear = (props) => {
    const [text, setText] = useState("");
    const [selection, setSelection] = useState({ selectionStart: 0, selectionEnd: 0 })
    const inputRef = useRef(null);

    useEffect(() => {
        if (props.value) {
            const newText = moment(props.value).format("MM/YYYY")
            if (newText !== text) setText(newText)
        }
    }, [props.value]);

    useEffect(() => {
        inputRef.current.selectionStart = selection.selectionStart
        inputRef.current.selectionEnd = selection.selectionEnd
    }, [selection])

    const onTextChange = (event) => {
        let value = event.target.value
        let final = ""

        for (let i = 0; i < value.length; i++) {
            if (final.length > 5) break

            if (/^[0-9]$/.test(value[i])) final += value[i]
        }

        let insertedSlash = false
        if (final.length > 2 && !final.includes('/')) {
            final = final.substring(0, 2) + '/' + final.substring(2);

            if (!text.includes('/')) insertedSlash = true
        }

        const selectionStart = event.target.selectionStart + (insertedSlash ? 1 : 0)
        const selectionEnd = event.target.selectionStart + (insertedSlash ? 1 : 0)

        if (value.length < 8) setText(final);
        setSelection({ selectionStart, selectionEnd })

        const formattedValue = parseDate(final);
        event.target.value = formattedValue;

        props.onChange(event);
    };

    const parseDate = (value) => {
        if (value.length !== 7) return null;

        const [month, year] = [value.substring(0, 2), value.substring(3)];

        return new Date(year, month - 1);
    };

    return (
        <div>
            <input
                name={props.name}
                placeholder={props.placeholder}
                className={props.className}
                value={text}
                onChange={onTextChange}
                ref={inputRef}
                disabled={props.disabled}
            />
        </div>
    );
};

InputMonthYear.propTypes = {
    name: string.isRequired,
    value: object,
    placeholder: string,
    className: string,
    disabled: bool,
    onChange: (event) => {},
};

InputMonthYear.defaultProps = {
    placeholder: "",
    className: null,
    disabled: false,
};

export default InputMonthYear;
